import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
export var useDebugger = function useDebugger() {
  var showDebug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var debugActive = useRef(showDebug);
  useEffect(function () {
    document.addEventListener('keydown', handleKeyDown); //Component didunmount

    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []); // useEffect(() => {
  //   switchDebug()
  // }, [debugActive.current])

  var handleKeyDown = function handleKeyDown(event) {
    //console.log("useDebugger -> event", event)
    // se SHIFT + D premuto
    var KEY = 68; //console.log("handleKeyDown", event)

    if (event.keyCode === KEY && event.shiftKey && event.ctrlKey) {
      debugActive.current = !debugActive.current;
      switchDebug();
    }
  };

  var switchDebug = function switchDebug() {
    console.log('switchDebug -> switchDebug', debugActive.current);

    if (debugActive.current) {
      //show/hide jsonlog debugging
      document.querySelectorAll('.debug').forEach(function (el) {
        return el.classList.remove('hidden');
      });
      console.warn('Debug messagges VISIBLE');
    } else {
      //show/hide jsonlog debugging
      document.querySelectorAll('.debug').forEach(function (el) {
        return el.classList.add('hidden');
      });
      console.warn('Debug messagges HIDDEN');
    }
  };

  return [debugActive.current];
};
export var Debug = function Debug(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    className: "debug hidden",
    children: children
  });
};